import React from 'react'
import { Divider, makeStyles, tokens } from '@fluentui/react-components'
import { DraggableModal } from '../common/modal/DraggableModal'
import { Text } from '../common/text/Text'
import { Activity } from '../../api/schemas/schema'
import { formatDate } from '../../helpers/stringHelper'
import { t } from '../../i18n/i18n'

const useStyles = makeStyles({
   row: {
      display: 'flex',
      alignItems: 'center',
      gap: tokens.spacingHorizontalS,
      padding: `${tokens.spacingVerticalS} 0`,
      cursor: 'pointer',
   },
   colorDot: {
      width: '10px',
      height: '10px',
      minWidth: '10px',
      borderRadius: '50%',
   },
   empty: {
      padding: tokens.spacingVerticalL,
      textAlign: 'center',
   },
})

type ModalActivityListProps = {
   open: boolean
   title: string
   activities: Activity[]
   getColor: (activity: Activity) => string
   onActivityClick: (activity: Activity) => void
   close: () => void
}
export const ModalActivityList = ({ open, title, activities, getColor, onActivityClick, close }: ModalActivityListProps) => {
   const classes = useStyles()
   return (
      <DraggableModal title={title} open={open} onClose={close}>
         {activities.length === 0 ? (
            <Text className={classes.empty}>{t('NoActivitiesInPeriod')}</Text>
         ) : (
            activities.map((activity, index) => (
               <React.Fragment key={activity.id}>
                  <div className={classes.row} onClick={() => onActivityClick(activity)}>
                     <span className={classes.colorDot} style={{ backgroundColor: getColor(activity) }} />
                     <div>
                        <Text weight="medium" noMargin>
                           {activity.title}
                        </Text>
                        <Text size={200} noMargin>{`${formatDate(activity.startDate)} - ${formatDate(activity.endDate)}`}</Text>
                     </div>
                  </div>
                  {index < activities.length - 1 && <Divider />}
               </React.Fragment>
            ))
         )}
      </DraggableModal>
   )
}
